import React, { useState, useEffect } from 'react'
import Navbar from './Navbar'
import Footer from './Footer';
import '../hamcss/lsp.css';
import investerBanner from '../assests/investor relationship/handshake.webp';
import { FloatingWhatsApp } from 'react-floating-whatsapp';
import DotRing from '../component/dot/DotRing';

// 1. LSP partner logo file (place at src/assests/lsp/bharatpe-money-logo.png)
import bharatpeLogo from '../assests/lsp/bharatpe-money-logo.png';
import apple from '../assests/lsp/apple.png';
import play from '../assests/lsp/play.png';

// Simple inline SVG badges for Play Store / App Store (no PNG assets needed)
const GooglePlayBadge = () => (
    <svg viewBox="0 0 135 40" className="lsp_store_svg" xmlns="http://www.w3.org/2000/svg">
        <rect width="135" height="40" rx="6" fill="#000" />
        <text x="14" y="17" fill="#fff" fontSize="8" fontFamily="Arial, sans-serif">GET IT ON</text>
        <text x="14" y="30" fill="#fff" fontSize="13" fontFamily="Arial, sans-serif" fontWeight="600">Google Play</text>
        <polygon points="4,6 4,34 18,20" fill="#00D2FF" />
    </svg>
);

const AppleStoreBadge = () => (
    <svg viewBox="0 0 135 40" className="lsp_store_svg" xmlns="http://www.w3.org/2000/svg">
        <rect width="135" height="40" rx="6" fill="#000" />
        <text x="18" y="17" fill="#fff" fontSize="8" fontFamily="Arial, sans-serif">Download on the</text>
        <text x="18" y="30" fill="#fff" fontSize="13" fontFamily="Arial, sans-serif" fontWeight="600">App Store</text>
        <path d="M9 12c1.5-2 4-2 5-1 1-1 3-1 4 0 1 1 1 3-1 5-1 1-2 2-3 2s-2-1-3-2c-2-2-3-3-2-4z" fill="#fff" />
    </svg>
);

// 2. Real disclosure data pulled from LSP_Details_-_SGFL_Website.xlsx
const lspData = {
    applicationName: 'BharatPe for Business',
    lspName: 'BharatPe Money (Resilient Digi Services Private Limited)',
    lspAddress: 'Building No. 8 Tower C, 12th Floor, DLF Cyber City, Gurgaon-122002 Haryana',
    dlaName: 'BharatPe for Business',
    dlaAddress: 'Building No. 8 Tower C, 12th Floor, DLF Cyber City, Gurgaon-122002 Haryana',
    servicesOffered: 'Customer acquisition, Collection & customer service',
    grievanceOfficerName: 'Mr. Rashid Ahmed',
    grievanceAddress: 'Building No. 8 Tower C, 12th Floor, DLF Cyber City, Gurgaon-122002 Haryana',
    grievanceEmail: 'nodalofficer@bharatpemoney.com',
    grievancePhone: '+91 9899355922',
    rbiCmsPortal: 'https://cms.rbi.org.in/cms/indexpage.html#eng',
    rbiSachetPortal: 'https://sachet.rbi.org.in/',
    dlaLspWebsite: 'https://bharatpemoney.com/lending-partners.html',
    privacyPolicy: 'https://bharatpemoney.com/documents/privacy-policy.pdf',
    googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.bharatpe.app&hl=en_IN',
    appleStoreUrl: 'https://apps.apple.com/in/app/bharatpe-for-business/id1329385873',
};

const LendingServiceProvider = () => {
    const [showPopup, setShowPopup] = useState(false);
    const [showTable, setShowTable] = useState(false);

    // Automatically show the BharatPe Money logo popup as soon as this page opens
    useEffect(() => {
        setShowPopup(true);
    }, []);

    const closePopup = () => {
        setShowPopup(false);
    };

    const handleLogoClick = () => {
        setShowPopup(false);
        setShowTable(true);
    };

    return (
        <>
            <DotRing />
            <Navbar />

            <section>
                <div className="BreadArea" style={{
                    backgroundImage: `url(${investerBanner})`,
                }}>
                    <div className="container">
                        <h2>Lending Service Provider (LSP)</h2>
                    </div>
                </div>
            </section>

            {showPopup && (
                <div className="lsp_modal_overlay" onClick={closePopup}>
                    <div className="lsp_modal_content" onClick={(e) => e.stopPropagation()}>
                        <button className="lsp_modal_close" onClick={closePopup}>&times;</button>

                        <div className="lsp_logo_popup" onClick={handleLogoClick}>
                            <img
                                src={bharatpeLogo}
                                alt="BharatPe Money"
                                className="lsp_popup_logo_img"
                            />
                            <p className="lsp_click_hint">Click the logo to view details</p>
                        </div>
                    </div>
                </div>
            )}

            {showTable && (
                <div className="lsp_container lsp_table_section">
                    <h4>Lending Service Provider (LSP)</h4>
                    <table className="lsp_table">
                        <tbody>
                            <tr>
                                <td>Application Name</td>
                                <td>{lspData.applicationName}</td>
                            </tr>
                            <tr>
                                <td>LSP Details (Name and Address)</td>
                                <td>{lspData.lspName}<br />{lspData.lspAddress}</td>
                            </tr>
                            <tr>
                                <td>DLA Details (Name and Address)</td>
                                <td>{lspData.dlaName}<br />{lspData.dlaAddress}</td>
                            </tr>
                            <tr>
                                <td>Services Offered</td>
                                <td>{lspData.servicesOffered}</td>
                            </tr>
                            <tr>
                                <td>Grievance Redressal Official (DLA & LSP)</td>
                                <td>
                                    Name: {lspData.grievanceOfficerName}<br />
                                    Address: {lspData.grievanceAddress}<br />
                                    Email: <a href={`mailto:${lspData.grievanceEmail}`}>{lspData.grievanceEmail}</a><br />
                                    Phone: <a href={`tel:${lspData.grievancePhone}`}>{lspData.grievancePhone}</a>
                                </td>
                            </tr>
                            <tr>
                                <td>RBI CMS Portal</td>
                                <td><a href={lspData.rbiCmsPortal} target="_blank" rel="noopener noreferrer">{lspData.rbiCmsPortal}</a></td>
                            </tr>
                            <tr>
                                <td>RBI Sachet Portal</td>
                                <td><a href={lspData.rbiSachetPortal} target="_blank" rel="noopener noreferrer">{lspData.rbiSachetPortal}</a></td>
                            </tr>
                            <tr>
                                <td>DLA & LSP Website</td>
                                <td><a href={lspData.dlaLspWebsite} target="_blank" rel="noopener noreferrer">{lspData.dlaLspWebsite}</a></td>
                            </tr>
                            <tr>
                                <td>Privacy Policy</td>
                                <td><a href={lspData.privacyPolicy} target="_blank" rel="noopener noreferrer">{lspData.privacyPolicy}</a></td>
                            </tr>
                            <tr>
                                <td>Download App</td>
                                <td className="lsp_store_icons">
                                    <a href={lspData.googlePlayUrl} target="_blank" rel="noopener noreferrer" aria-label="Get it on Google Play">
                                        <img class="store-badge"
                                        src={play}
                                        alt="Play Store"
                                    />
                                    </a>
                                    <a href={lspData.appleStoreUrl} target="_blank" rel="noopener noreferrer" aria-label="Download on the App Store">
                                        <img class="store-badge"
                                        src={apple}
                                        alt="App Store"
                                    />
                                    </a>
                                    
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}

            <div>
                <FloatingWhatsApp phoneNumber="919205556122" accountName="" />
            </div>

            <Footer />
        </>
    )
}

export default LendingServiceProvider